import Portal = require("portal-gis");
import Utils = require("../utils");
import Mediator = require("../mediator");
import Base = require("./base-command");
import Model = require("../models/base-model");
import View = require("../controls/view");

// compatible with bookmark-picker controller 
// TODO: how to document/discover compatibilities...a workflow UI could eliminate CE
class Command extends Base<{
    out: {
        viewArgs: {
            model: Model<Portal.MapBookmarkLeaf>
        };
    }
}> {

    static about = `
Handles a bookmark selection event
`;

    execute(args = this.args) {
        let mediator = this.mediator;

        let source = mediator.api.bookmarks;

        let geom = JSON.parse(`[${args.out.viewArgs.model.data.extent}]`);

        let extent = {
            geometry: geom,
            spatialReference: { wkid: "EPSG:4326" }
        };

        mediator.mapView(v => {
            v.extent = extent;
            this.trigger({
                geom: geom,
                extent: extent
            });
        });

    }

}

export = Command;  